export var HistoryTypes;
(function (HistoryTypes) {
    HistoryTypes["outerTransfers"] = "\u0412\u043D\u0435\u0448\u043D\u0438\u0435 \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u044B";
    HistoryTypes["innerTransfers"] = "\u0412\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0435 \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u044B";
    HistoryTypes["bonusesPayout"] = "\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0431\u043E\u043D\u0443\u0441\u043E\u0432";
})(HistoryTypes || (HistoryTypes = {}));
